import React from 'react';

const QuestionDetails = ({ element, questions, scores }) => {
  if (!questions || questions.length === 0) {
    return (
      <div className="text-center text-gray-400 mt-10">
        <p className="text-sm">Keine Fragen für dieses Element gefunden.</p>
      </div>
    );
  }

  // Helper to determine status color based on score
  const getStatusColor = (score) => {
    if (score === 0) return 'text-gray-400 bg-gray-100';
    if (score < 3.5) return 'text-red-600 bg-red-50';
    if (score < 5.5) return 'text-yellow-600 bg-yellow-50';
    return 'text-green-600 bg-green-50';
  };

  return (
    <div className="space-y-2">
      {questions.map((question) => {
        const score = scores[question.id] || 0;
        const colorClass = getStatusColor(score);
        
        return (
          <div 
            key={question.id} 
            className="flex items-start p-2 rounded hover:bg-gray-50 transition-colors"
          >
            <div className={`flex-shrink-0 w-10 text-center font-bold text-sm py-0.5 rounded ${colorClass} mr-3`}>
              {score > 0 ? score : '-'}
            </div>
            
            <div className="flex-grow min-w-0 pt-0.5">
              <p className="text-sm text-gray-700 leading-snug">
                {question.text}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default QuestionDetails;